<template>
  <img
    :src="src"
    :alt="alt"
    :loading="eager ? 'eager' : 'lazy'"
    decoding="async"
    class="saimg"
    :class="{ 'saimg--cover': cover }"
    :style="imgStyle"
    >
</template>

<script setup>
import { computed } from 'vue';
// Native lazy <img> with object-fit — replaces Vuetify's <v-img>.
const props = defineProps({
  src: { type: String, default: '' },
  alt: { type: String, default: '' },
  cover: { type: Boolean, default: false },
  contain: { type: Boolean, default: false },
  eager: { type: Boolean, default: false },
  width: { type: [Number, String], default: '' },
  height: { type: [Number, String], default: '' },
});
const px = (v) => (typeof v === 'number' ? `${v}px` : v);
// object-fit goes inline so it always wins over scoped parent rules (no specificity
// ties); contain by default keeps logos from stretching the way a bare <img> would.
const imgStyle = computed(() => {
  const s = { objectFit: props.cover ? 'cover' : 'contain' };
  if (props.width !== '') s.width = px(props.width);
  if (props.height !== '') s.height = px(props.height);
  return s;
});
</script>

<style scoped>
.saimg { display: block; max-width: 100%; }
/* fill the box for cover images; object-fit comes from inline style */
.saimg--cover { width: 100%; height: 100%; }
</style>
